import type { HabitMeasure } from '@goaltree/backend/convex/lib/habitMeasure'
import type { TFunction } from 'i18next'

export {
  type HabitCadence,
  POPULAR_HABITS,
  POPULAR_HABIT_CATEGORIES,
} from '@goaltree/backend/convex/lib/popularHabits'

// Minutes habits share the meditate preset's localized unit.
export const popularMeasure = (
  t: TFunction,
  h: { measure?: HabitMeasure },
): HabitMeasure | undefined =>
  h.measure && { ...h.measure, unit: t('numberHabit.presets.meditate.unit') }
